import { Trans } from '@lingui/macro';
import { ViewSidebar } from '@mui/icons-material';
import { Skeleton } from '@mui/material';
import { Box } from '@mui/system';
import { Suspense } from 'react';
import InterfaceTab from '../components/InterfaceTab';

export const useTabs = (userId: number | null) => {
  const tabs = [
    {
      id: 'interface',
      label: (
        <Box display="flex" alignItems="center" gap={2}>
          <ViewSidebar fontSize="small" />
          <Trans>Interfaz</Trans>
        </Box>
      ),
      component: (
        <Suspense fallback={<Skeleton variant="rounded" height={400} />}>
          <InterfaceTab userId={userId} />
        </Suspense>
      ),
    },
  ];

  return tabs;
};
